import moment from 'moment'

export const buildPostDiscountData = (originalData) => {
  let data = {
    ID: originalData.id,
    Title: originalData.title,
    FromDate: moment(originalData.dateFrom, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    ToDate: moment(originalData.dateTo, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    Customers: [],
    Items: [],
    // enabled: originalData.enabled,
  }

  if (typeof originalData.assignedCustomers != 'undefined' && originalData.assignedCustomers) {
    data.Customers = originalData.assignedCustomers.map((item) => {
      return item.value
    })
  }

  if (typeof originalData.id != 'undefined' && originalData.id) {
    data.ID = originalData.id
  }

  // if(data.enabled == 0) {
  //     data.enddate = null;
  // }

  data.Items = originalData.items.map((item) => {
    return {
      ProductID: item.id,
      DiscountType: item.promotionType,
      Amount: item.discountedPrice,
    }
  })

  return data
}

/**
 * Helper to convert the originalData to GraphQL params
 *
 * @param originalData
 * @returns {{Customers: [], Title: *, FromDate: *, ToDate: *, Items: []}}
 */
export const buildPostOngoingDealData = (originalData) => {
  let data = {
    Title: originalData.title,
    // Description: originalData.Description,
    // SupplierReference: originalData.supplierReference,
    FromDate: moment(originalData.durationFrom, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    ToDate: moment(originalData.durationTo, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    Customers: [],
    Items: [],
    // Enabled: 1,
  }

  if (typeof originalData.id != 'undefined' && originalData.id) {
    data.ID = originalData.id
  }

  if (typeof originalData.assignedCustomers != 'undefined' && originalData.assignedCustomers) {
    data.Customers = originalData.assignedCustomers.map((item) => {
      return item.value
    })
  }

  Object.entries(originalData.modifiedRows).forEach(([key, value]) => {
    const { productID, lastKey, lastValue, flatDiscountValue } = value
    let promotionType

    /**
     *  Use flat discount at the moment
     *  https://jira.visualr.dev/browse/PAR-1513
     */
    promotionType = 3

    data.Items.push({
      ProductID: productID,
      DiscountType: promotionType,
      Amount: flatDiscountValue,
    })
  })

  return data
}

export const buildPromotionData = (originalData) => {
  let data = {
    FromDate: moment(originalData.durationFrom, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    ToDate: moment(originalData.durationTo, 'DD/MM/YYYY').format('YYYY-MM-DD'),
  }

  const mapping = new Map([
    ['ID', 'id'],
    ['Title', 'title'],
    // ['supplierreference', 'supplierReference'],
    // ['description', 'description'],
    // ['type', 'discountType'],
    ['BuyQty', 'buyQuantity'],
    ['GetQty', 'getQuantity'],
    // ['BuyProduct', 'buyProduct'], // used on case discount
    ['BuyProducts', 'buyProducts'], // used on bonus
    ['GetProducts', 'getProducts'], // used on bonus
    // ['casediscounttype', 'caseDiscountType'], // used on case discount
    // ['casediscountvalue', 'caseDiscountValue'], // used on case discount
    // ['enabled', 'enabled'],
  ])

  // Convert data based on the mapping
  mapping.forEach((reactKey, requestKey) => {
    if (typeof originalData[reactKey] != 'undefined') {
      data[requestKey] = originalData[reactKey]
    }
  })

  if (typeof originalData.assignedCustomers != 'undefined') {
    data.Customers = originalData.assignedCustomers.map((item) => {
      return item.value
    })
  }

  // TODO: maybe later?
  // // Overwrite type
  // if(data.type == 'Bonus') {
  //     data.type = 2;
  // }
  //
  // if(data.enabled == 0) {
  //     data.enddate = null;
  // }

  if (!data.ID) {
    delete data.ID
  }

  return data
}

/**
 * Check If better discount is available for the item
 * @param {*} data
 * @returns
 */
export const updatedComparedDealBuilderSubmissionData = (stateData, discountedItems) => {
  const { Discounts, PromoDeals } = discountedItems

  /**
   * parse the data into JSON
   */
  const discounts = JSON.parse(Discounts)
  const promoDeals = JSON.parse(PromoDeals)

  /**
   * if discount length is > 0 then use discount else use promo deal
   */
  const dataToShow = Object.keys(discounts).length > 0 ? discounts : promoDeals

  console.log(dataToShow, 'dataToShow')
  /**
   * get all keys of dataToShow
   */
  const betterDiscountItemIds = Object.keys(dataToShow)

  /**
   * filter the state data and add betterExists key
   */
  return stateData.map((item) => {
    const { sku } = item
    const betterExists = betterDiscountItemIds.includes(sku)

    return {
      ...item,
      betterExists,
    }
  })
}

export const buildDealBuilderSubmissionData = (originalData) => {
  let data = {
    ...originalData,
    FromDate: moment(originalData.FromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
    ToDate: moment(originalData.ToDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
  }

  if (data.AppliesTo == 'Customer' && typeof originalData.Customers != 'undefined') {
    data.Customers = originalData.Customers.map((item) => {
      return item.value
    })
  } else {
    data.Customers = []
  }

  if (data.AppliesTo == 'Customer Group' && typeof originalData.Zones != 'undefined') {
    // data.PromotionZoneID = originalData.Zones.value
    data.PromotionZoneID = originalData.Zones.map((item) => {
      return parseInt(item.value)
    })
  } else {
    data.PromotionZoneID = []
  }

  if (typeof originalData.modifiedRows != 'undefined') {
    data.Items = []

    Object.entries(originalData.modifiedRows).forEach(([key, value]) => {
      const { productID, lastKey, lastValue, flatDiscountValue, modified } = value

      if (!modified) {
        delete originalData.modifiedRows[productID]
        return
      }

      let promotionType

      /**
       *  Use flat discount at the moment
       *  https://jira.visualr.dev/browse/PAR-1513
       */
      promotionType = 3

      data.Items.push({
        ProductID: productID,
        DiscountType: promotionType,
        Amount: flatDiscountValue,
      })
    })
  }

  if (typeof originalData.QuantityDependentOffPercentage == 'undefined') {
    data.QuantityDependentOffPercentage = 0
  }
  if (typeof originalData.QuantityDependentOffValue == 'undefined') {
    data.QuantityDependentOffValue = 0
  }

  if (!data.ID) {
    delete data.ID
  }

  return data
}
